import styled from 'styled-components';

import { sizes } from '~/utils/style-utils';
import Icon from '~/components/icon';
import { calcModalHeight } from '~/utils/layout-utils';

export const DESKTOP_MODAL_HEIGHT = 452;

export const DESKTOP_PRIMARY_SECTION_WIDTH = 375;
export const DESKTOP_SECONDARY_SECTION_WIDTH = 345;
export const DESKTOP_TOTAL_WIDTH = DESKTOP_PRIMARY_SECTION_WIDTH + DESKTOP_SECONDARY_SECTION_WIDTH;

export const breakpointDesktop = `@media (min-height: ${DESKTOP_MODAL_HEIGHT}px) and (min-width: ${sizes.lg}px)`;

export const GameInfoWrapper = styled.div<{ hasStaticHeader: boolean }>`
	background-color: var(--game-info-background-color);

	height: ${props =>
		calcModalHeight({ customHeight: '100dvh', small: true, hasStaticHeader: props.hasStaticHeader })};

	${breakpointDesktop} {
		box-shadow: -2px 0px 3px rgba(0, 0, 0, 0.18);
		overflow: hidden;
		width: ${DESKTOP_TOTAL_WIDTH}px;
		height: ${DESKTOP_MODAL_HEIGHT}px;
		border-radius: 12px;
	}

	p,
	button {
		overflow-wrap: break-word;
		word-wrap: break-word;
		hyphens: auto;
	}
`;

export const GameInfoContainer = styled.div`
	display: grid;
	width: 100%;
	grid-gap: 0px;

	grid-template-rows: auto 1fr;
	min-height: 100%;

	@media (min-height: ${DESKTOP_MODAL_HEIGHT}px) and (min-width: ${sizes.lg}px) {
		grid-template-columns: ${DESKTOP_PRIMARY_SECTION_WIDTH}px 1fr;
		grid-template-rows: none;
		min-height: unset;
		height: 100%;
	}
`;

export const StyledIcon = styled(Icon)<{ color: string }>`
	fill: ${({ color }) => color};
`;
